import { render, staticRenderFns } from "./BridgeFAQ.vue?vue&type=template&id=76a0deb6&scoped=true"
import script from "./BridgeFAQ.vue?vue&type=script&lang=js"
export * from "./BridgeFAQ.vue?vue&type=script&lang=js"
import style0 from "./BridgeFAQ.vue?vue&type=style&index=0&id=76a0deb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a0deb6",
  null
  
)

export default component.exports